import React, { useContext, useEffect, useState } from "react";
import { Grid, Button } from "@mui/material";
import "../../../styles/Layout/Admin_Styles/_AdminObjection.scss";
import { Link, useNavigate } from "react-router-dom";
import { apisPath, paths } from "../../../utils/path";
import { authHttp } from "../../services/utility";
import { AuthContext } from "../../../context/AuthContext";
import LoadingImg from "../../../assets/Loading.gif";
import { exportToExcel } from "../../../utils/exportToExcel";
import { decrypt, encrypt } from "../../../utils/encryptDecrypt";


const ExportButton = ({ apiUrl, fileName, headers }) => {
  const [loading, setLoading] = useState(false);
  const { setIsLoading, setAlertState } = useContext(AuthContext);

  const fetchDataAndExport = async () => {
    setLoading(true);
    setIsLoading(true);
    try {
      const response = await authHttp.get(apiUrl);
      let data = response?.data?.data; // Get the Data from API
      if (!data || data.length === 0) {
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: "No data found",
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: response?.status === 401,
          sessionType: "admin",
        }));
      } else {
        const conState = {
          roll_no: "",
          isSame: false,
          s_no: 0,
        };
        data = data?.map((item, index) => {
          if (conState.roll_no !== item?.roll_no) {
            conState.roll_no = item?.roll_no;
            conState.isSame = false;
            conState.s_no += 1;
          } else {
            conState.isSame = true;
          }
          return {
            ...item,
            sno: conState.isSame ? "" : conState.s_no,
            qsno: index + 1, //serial number for Q.S. No.
            candidate_name: item?.candidate_name ? decrypt(item?.candidate_name) : "", // Decrypt candidate_name in the data
          }
        });
        exportToExcel(data, fileName, headers);
      }
    } catch (error) {
      setIsLoading(false);
      setAlertState((prev) => ({
        ...prev,
        open: true,
        title: error?.response?.data?.msg,
        btnTxt: "CLOSE",
        status: "fail",
        isSessionExpire: error?.response?.status === 401,
        sessionType: "admin",
      }));
    }
    setLoading(false);
    setIsLoading(false);
  };

  return (
    <Button onClick={fetchDataAndExport} disabled={loading} variant="outlined" color="success">
      {loading ? "Exporting..." : "Export Excel (Paid)"}
    </Button>
  );
};

const AdminObjection = () => {
  const { setIsLoading, setAlertState } = useContext(AuthContext);
  const navigate = useNavigate();
  const [papers, setPapers] = useState([]);

  const candidateReportHeaders = [
    { key: "sno", title: "S No." },
    { key: "roll_no", title: "Roll No." },
    { key: "candidate_name", title: "Candidate Name" },
    { key: "series", title: "Series" },
    { key: "qno", title: "Q. No." },
    { key: "aayog_answer", title: "Aayog Answer" },
    { key: "candidate_answer", title: "Candidate Answer" },
    { key: "qsno", title: "Q.S. No." },
    { key: "a_acc", title: "A Acc" },
    { key: "b_acc", title: "B Acc" },
    { key: "c_acc", title: "C Acc" },
    { key: "d_acc", title: "D Acc" },
  ];
  const quesReportHeaders = [
    { key: "qsno", title: "S No." },
    { key: "series_a_wise_qno", title: "Series-A Wise Q. No." },
    { key: "aayog_answer", title: "Aayog Answer" },
    { key: "answer_according_to_candidates", title: "Answer According To Candidate(s)" },
    { key: "answer_according_to_subject_expert", title: "Answer According To Subject Expert" },
    { key: "series_b_wise_qno", title: "Series-B Wise Q. No." },
    { key: "series_c_wise_qno", title: "Series-C Wise Q. No." },
    { key: "series_d_wise_qno", title: "Series-D Wise Q. No." },
  ];

  useEffect(() => {
    getSubjects();
  }, []);

  const getSubjects = () => {
    authHttp
      .get(apisPath?.admin?.getPapers)
      .then((res) => {
        setPapers(res?.data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const Loading = () => (
    <div className="loading objection-loader">
      <span>
        <img src={LoadingImg} alt="loading img" className="circle-process" />
      </span>
      <h1>Loading...</h1>
    </div>
  );

  return (
    <div className="admin-objection">
      <div className="admin-objection--header">
        <h2>Objection Reports</h2>
      </div>
      {papers?.length === 0 && <Loading />}
      {papers &&
        papers
          ?.slice()
          ?.sort((a, b) => a?.subject_code - b?.subject_code)
          ?.map((paper) => {

            return (
              <Grid container>
                <div className="admin-objection--subHeader">
                  <h2>
                    {paper?.subject_desc}
                  </h2>
                </div>
                <Grid container spacing={2}>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className="admin-objection--card--singleCard">
                      <span>Question Wise Report</span>
                      {/* <Link
                  to={`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionreport}`}
                > */}
                      <div className="admin-objection--card--buttons customSecFlex">
                        <Button
                          variant="outlined"
                          color="success"
                          onClick={() => {
                            navigate(
                              `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionreport}`,
                              { state: { paper: paper, type: "Paid" } }
                            );
                          }}
                        >
                          View (Paid)
                        </Button>
                        <Button
                          variant="outlined"
                          color="success"
                          onClick={() => {
                            navigate(
                              `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionreport}`,
                              { state: { paper: paper, type: "Unpaid" } }
                            );
                          }}
                        >
                          View (Unpaid)
                        </Button>
                        <ExportButton
                          apiUrl={`${apisPath?.admin?.questionWiseObjections}/${btoa(encrypt(paper?.id))}/Paid`}
                          fileName={`QuestionWise_Report_${paper?.subject_desc}`}
                          headers={quesReportHeaders}
                        />
                      </div>
                      {/* </Link> */}
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className="admin-objection--card--singleCard">
                      <span>Candidate Wise Report</span>
                      {/* <Link
                  to={`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidatereport}`}
                > */}
                      <div className="admin-objection--card--buttons customSecFlex">
                        <Button
                          variant="outlined"
                          color="success"
                          onClick={() =>
                            navigate(
                              `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidatereport}`,
                              { state: { paper: paper, type: "Paid" } }
                            )
                          }
                        >
                          View (Paid)
                        </Button>
                        <Button
                          variant="outlined"
                          color="success"
                          onClick={() =>
                            navigate(
                              `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidatereport}`,
                              { state: { paper: paper, type: "Unpaid" } }
                            )
                          }
                        >
                          View (Unpaid)
                        </Button>
                        <ExportButton
                          apiUrl={`${apisPath?.admin?.candidateWiseObjections}/${btoa(encrypt(paper?.id))}/Paid`}
                          fileName={`CandidateWise_Report_${paper?.subject_desc}`}
                          headers={candidateReportHeaders}
                        />
                      </div>
                      {/* </Link> */}
                    </div>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={12}>
                    <div className="admin-objection--card--singleCard">
                      <span>Question With Image Wise Report</span>
                      {/* <Link
                  to={`${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionimgreport}`}
                > */}
                      <div className="admin-objection--card--buttons customSecFlex">
                        <Button
                          variant="outlined"
                          color="success"
                          onClick={() =>
                            navigate(
                              `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionimgreport}`,
                              { state: { paper: paper, type: "Paid" } }
                            )
                          }
                        >
                          View (Paid)
                        </Button>
                        <Button
                          variant="outlined"
                          color="success"
                          onClick={() =>
                            navigate(
                              `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.questionimgreport}`,
                              { state: { paper: paper, type: "Unpaid" } }
                            )
                          }
                        >
                          View (Unpaid)
                        </Button>
                      </div>
                      {/* </Link> */}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
    </div>
  );
};

export default AdminObjection;
